import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { Caption, CardTitleShort } from '../../../design/components/Typography';

import type { FunctionComponent, MouseEventHandler } from 'react';

type LearningOpportunityCardShortProps = {
    readonly id: string;
    readonly onClick?: () => void;
    readonly title: string;
};

export const LearningOpportunityCardShort: FunctionComponent<LearningOpportunityCardShortProps> = ({
    id,
    onClick,
    title,
}) => {
    const { actions, translate } = useContext(ApplicationContext);

    const onCardClicked: MouseEventHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();

        onClick?.();

        actions.navigateTo(`/learning-opportunities/${id}`);
    };

    return (
        <Card
            sx={{ borderRadius: '8px', cursor: 'pointer', height: '96px', paddingX: 3, paddingY: 2, width: '354px' }}
            onClick={onCardClicked}
        >
            <Box
                sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '12px' }}
            >
                <LocalLibraryOutlinedIcon sx={{ color: 'learning-opportunity.main', fontSize: '12px' }} />
                <Caption type="learningOpportunity">
                    {translate('components.learning-opportunity-card.caption')}
                </Caption>
            </Box>
            <CardTitleShort>{title}</CardTitleShort>
        </Card>
    );
};
